import { observer } from 'mobx-react-lite'
import type { PropsWithChildren } from 'react'
import type { VirtualListItemFunctionComponent } from './VirtualList'
import styles from './VirtualList.module.scss'
import { VirtualListItemComponent } from './VirtualListItemComponent'
import type { VirtualListStore } from './VirtualListStore'

export const VirtualListRows = observer(function VirtualListRows<T>({
  store,
  renderItem,
  children,
}: PropsWithChildren<{
  store: VirtualListStore<T>
  renderItem: VirtualListItemFunctionComponent<T>
}>) {
  return (
    <div className={styles.list} data-testid="VirtualListItems">
      {store.virtualRows.map(row => (
        <VirtualListItemComponent
          key={row.key}
          row={row}
          renderItem={renderItem}
        />
      ))}
      {children}
    </div>
  )
})
